export const google_maps_loader_key = process.env.VUE_APP_GOOGLE_MAPS_LOADER
export const clover_url = process.env.VUE_APP_CLOVER_URL
export const clover_client_id = process.env.VUE_APP_CLOVER_CLIENT_ID
export const clover_redirect_url = process.env.VUE_APP_CLOVER_REDIRECT_URL
export const clover_great_table_client_id = process.env.VUE_APP_CLOVER_GREAT_TABLE_CLIENT_ID
export const clover_great_table_redirect_url = process.env.VUE_APP_CLOVER_GREAT_TABLE_REDIRECT_URL